import { createFeatureSelector, createSelector } from '@ngrx/store';
import { WartungsfensterListItemStatus } from 'app/core/services/api-client';
import { ISharedAreaState } from 'app/modules/shared-area/shared-area.module';

export const getSharedAreaState = createFeatureSelector<ISharedAreaState>('shared');

export const getSystemInfoState = createSelector(
  getSharedAreaState,
  (shared: ISharedAreaState) => shared.systemInfo
);

export const isMaintenanceWindowRunning = createSelector(
  getSystemInfoState,
  state => state.wartungsfenster.some(window => window.status && window.status === WartungsfensterListItemStatus.Aktiv)
);
